import { render, staticRenderFns } from "./ingredient.vue?vue&type=template&id=f4792f18"
import script from "./ingredient.vue?vue&type=script&lang=js"
export * from "./ingredient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4792f18')) {
      api.createRecord('f4792f18', component.options)
    } else {
      api.reload('f4792f18', component.options)
    }
    module.hot.accept("./ingredient.vue?vue&type=template&id=f4792f18", function () {
      api.rerender('f4792f18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Nutrition/manage/ingredient.vue"
export default component.exports